import React from "react";
import { motion } from "framer-motion";

import { SimpleLoaderProps } from "./SimpleLoader.types";

import "./SimpleLoader.scss";

const ANIMATION_TIME = 1.0;

const SimpleLoader: React.FC<SimpleLoaderProps> = () => (
  <div data-testid="simple-loader" className="mp-molecules-simpleloader--main">
    <motion.div
      className="fill"
      animate={{
        width: ["0%", "100%"],
        x: ["0%", "0%", "50%", "100%"],
        opacity: [0.5, 1.0, 0.5],
        transition: {
          x: {
            repeat: Infinity,
            duration: ANIMATION_TIME,
          },
          width: {
            repeat: Infinity,
            duration: ANIMATION_TIME / 2,
            repeatDelay: ANIMATION_TIME / 2,
          },
          opacity: {
            repeat: Infinity,
            duration: ANIMATION_TIME,
          },
        },
      }}
    />
  </div>
);

export default SimpleLoader;
